

/* eslint-disable */

import ThkAddress from './ThkAddress'
// import { ec as Ec } from 'elliptic'
var Ec = require('elliptic').ec;

const bip39 = require('bip39');
const hdkey = require('hdkey');
const secp256k1 = new Ec('secp256k1')
var util = require('ethereumjs-util');


export const demoFunction = {
  async createMnemonicWords(){
    let mnemonicWords = await bip39.generateMnemonic();
    console.log('createMnemonicWords', mnemonicWords)
    return mnemonicWords;
  },
  // 根据助记词获得私钥
  async getPrivateKeyFromMnemonicWords(mnemonicWords){
    let seed = await bip39.mnemonicToSeed(mnemonicWords);
    //  使用 seed 产生 HD Wallet。如果要说更明确，就是产生 Master Key 并记录起来。
    let hdWallet = hdkey.fromMasterSeed(seed);
    let key1 = hdWallet.derive("m/44'/60'/0'/0/0");
    let privateKey = '0x' + key1._privateKey.toString('hex');
    console.log('privateKey', privateKey);
    return privateKey
  },
  // 获得公钥
  getPublicKeyFromPrivateKey(privateKey){
    let publicKey = util.bufferToHex(util.privateToPublic( util.toBuffer(privateKey)));
    console.log('publicKey', publicKey)
    return publicKey;
  },
  // 获得地址
  getAddressFromPublicKey(publicKey){
    //  使用 keypair 中的公钥产生 address。
    var address = util.pubToAddress(util.toBuffer(publicKey), true);
    //  基于BIP55协议对地址进行再次编码，获取最终ETH地址
    address = util.toChecksumAddress('0x' + address.toString('hex'));
    console.log('address', address)
    return address
  },


  // 进行签名
  signTransaction(transaction, privateKey){
    const signedTransaction = transaction;
    let privateKeyss = arrayify(privateKey);
    // console.log('#################privateKey=', privateKey)

    if (!privateKey) throw new Error('Private key not found')
    const keyPair = secp256k1.keyFromPrivate(privateKeyss)

    const toaddr = signedTransaction.to.substring(0, 2) === '0x' ? signedTransaction.to.substring(2) : signedTransaction.to
    const fromaddr = signedTransaction.from.substring(0, 2) === '0x' ? signedTransaction.from.substring(2) : signedTransaction.from
    let input = ""
    if (signedTransaction.input !== "") {
      input = signedTransaction.input.substring(0, 2) === '0x' ? signedTransaction.input.substring(2) : signedTransaction.input
    }

    let useLocal_str = "0"
    if (signedTransaction.useLocal){
      useLocal_str = "1"
    }else {
      signedTransaction.useLocal = false
    }

    let signStr = signedTransaction.chainId + "-" + fromaddr.toLowerCase() + "-" +
      toaddr.toLowerCase() + "-" + signedTransaction.nonce + "-" +
      useLocal_str + "-" + signedTransaction.value + "-" + input

    signStr = signStr + '-';
    if (signedTransaction.extra && signedTransaction.extra.length > 0){
      signStr = signStr + signedTransaction.extra.toString('hex')
    }else if(!signedTransaction.extra){
      signedTransaction.extra = ''
    }

    // const signStr = signedTransaction.chainId + fromaddr.toLowerCase() +
    //     toaddr.toLowerCase() + signedTransaction.nonce +
    //     signedTransaction.value + input
    const wallutils = new ThkAddress(privateKey)
    let sigbyte = wallutils.stringToByte(signStr)
    console.log("signStr", signStr)
    let sighash = wallutils.keccak256(sigbyte)
    console.log("sighash:", sighash.toString('hex'))

    let sign_byte = new Buffer(sighash.substring(2), 'hex')

    const signature = keyPair.sign(sign_byte, { canonical: true });

    console.log("signature", signature)
    signedTransaction.sig = `0x${signature.r.toString(16,64)}${signature.s.toString(16,64)}${signature.recoveryParam ? '1c' : '1b'}`
    console.log('#################signature=', signature)

    // const publicKeyConvert = `0x${keyPair.getPublic(false, 'hex')}`

    let publicKey = "0x04" + util.bufferToHex(util.privateToPublic(util.toBuffer(privateKey))).slice(2);

    // const pubKey = `0x04${wallutils.getPublicKeyToAddress(publicKeyConvert, false).slice(4)}`
    console.log('#################pubKey=', publicKey)

    signedTransaction.pub = publicKey
    console.log('#################signature=', signedTransaction.sig)

    return signedTransaction;
  }
}


function arrayify(value) {
  if (value == null) {
    // errors.throwError('cannot convert null value to array', errors.INVALID_ARGUMENT, { arg: 'value', value: value });
  }

  if (value && value.toHexString) {
    value = value.toHexString();
  }

  if (isHexString(value)) {
    value = value.substring(2);
    if (value.length % 2) { value = '0' + value; }

    var result = [];
    for (var i = 0; i < value.length; i += 2) {
      result.push(parseInt(value.substr(i, 2), 16));
    }

    return addSlice(new Uint8Array(result));

  } else if (typeof (value) === 'string') {
    if (value.match(/^[0-9a-fA-F]*$/)) {
      // errors.throwError('hex string must have 0x prefix', errors.INVALID_ARGUMENT, { arg: 'value', value: value });
    }
    // errors.throwError('invalid hexidecimal string', errors.INVALID_ARGUMENT, { arg: 'value', value: value });
  }

  if (isArrayish(value)) {
    return addSlice(new Uint8Array(value));
  }

  // errors.throwError('invalid arrayify value', { arg: 'value', value: value, type: typeof (value) });
}

function isHexString(value, length) {
  if (typeof (value) !== 'string' || !value.match(/^0x[0-9A-Fa-f]*$/)) {
    return false
  }
  if (length && value.length !== 2 + 2 * length) { return false; }
  return true;
}

function isArrayish(value) {
  if (!value || parseInt(value.length) != value.length || typeof (value) === 'string') {
    return false;
  }

  for (var i = 0; i < value.length; i++) {
    var v = value[i];
    if (v < 0 || v >= 256 || parseInt(v) != v) {
      return false;
    }
  }
  return true;
}


function addSlice(array) {
  if (array.slice) { return array }

  array.slice = function () {
    const args = Array.prototype.slice.call(arguments)
    return new Uint8Array(Array.prototype.slice.apply(array, args))
  }

  return array
}

